var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"table-condensed table-striped table-bordered"},[_vm._m(0),_vm._l((_vm.dataObject),function(value,key){return _c('tr',[_c('td',[_vm._v(_vm._s(key))]),_c('td',[_vm._v(_vm._s(value))])])})],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('th',{staticStyle:{"width":"150px"}},[_vm._v("Chave")]),_c('th',{staticStyle:{"width":"150px"}},[_vm._v("Valor")])])
}]

export { render, staticRenderFns }